<template>
    <div></div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
    created() {
        this.getUser();
    },
    methods:{
        ...mapActions('user',['getUser']),
    }
}
</script>